import { AxiosError } from 'axios';
import { createAsyncAction, ActionType, createAction } from 'typesafe-actions';
import { ErrorModel } from '../../../models/ComnModel';
import {
  initDron,
  DronData,
  DronState,
  SelectData,
  IdntfData
} from '../models/basisDronModel';

//# 목록 조회
const LIST_REQUEST = 'basis/dron/LIST_REQUEST';
const LIST_SUCCESS = 'basis/dron/LIST_SUCCESS';
const LIST_FAILURE = 'basis/dron/LIST_FAILURE';

//# 상세 조회
const DETAIL_REQUEST = 'basis/dron/DETAIL_REQUEST';
const DETAIL_SUCCESS = 'basis/dron/DETAIL_SUCCESS';
const DETAIL_FAILURE = 'basis/dron/DETAIL_FAILURE';

//## 생성
const CREATE_REQUEST = 'basis/dron/CREATE_REQUEST';
const CREATE_SUCCESS = 'basis/dron/CREATE_SUCCESS';
const CREATE_FAILURE = 'basis/dron/CREATE_FAILURE';

//## 수정
const UPDATE_REQUEST = 'basis/dron/UPDATE_REQUEST';
const UPDATE_SUCCESS = 'basis/dron/UPDATE_SUCCESS';
const UPDATE_FAILURE = 'basis/dron/UPDATE_FAILURE';

//## 삭제
const DELETE_REQUEST = 'basis/dron/DELETE_REQUEST';
const DELETE_SUCCESS = 'basis/dron/DELETE_SUCCESS';
const DELETE_FAILURE = 'basis/dron/DELETE_FAILURE';

//식별번호 목록 조회
const IDNTF_LIST_REQUEST = 'basis/idntf/IDNTF_LIST_REQUEST';
const IDNTF_LIST_SUCCESS = 'basis/idntf/IDNTF_LIST_SUCCESS';
const IDNTF_LIST_FAILURE = 'basis/idntf/IDNTF_LIST_FAILURE';

const DISPATCH_RESET_IDNTF = 'basis/idntf/IDNTF_RESET';

//식별번호 생성

const IDNTF_CREATE_REQUEST = 'basis/idntf/IDNTF_CREATE_REQUEST';
const IDNTF_CREATE_SUCCESS = 'basis/idntf/IDNTF_CREATE_SUCCESS';
const IDNTF_CREATE_FAILURE = 'basis/idntf/IDNTF_CREATE_FAILURE';

//식별번호 삭제
const IDNTF_DELETE_REQUEST = 'basis/idntf/IDNTF_DELETE_REQUEST';
const IDNTF_DELETE_SUCCESS = 'basis/idntf/IDNTF_DELETE_SUCCESS';
const IDNTF_DELETE_FAILURE = 'basis/idntf/IDNTF_DELETE_FAILURE';

//그룹 선택
const SELECT_GROUP = 'basis/dron/SELECT_GROUP';

export const LIST = createAsyncAction(LIST_REQUEST, LIST_SUCCESS, LIST_FAILURE)<
DronState,
  { data: DronData[]; count: number,total: number },
  AxiosError
>();

export const IDNTF_LIST = createAsyncAction(
  IDNTF_LIST_REQUEST,
  IDNTF_LIST_SUCCESS,
  IDNTF_LIST_FAILURE
)<number, { data: IdntfData[]; count: number }, AxiosError>();

export const DETAIL = createAsyncAction(
  DETAIL_REQUEST,
  DETAIL_SUCCESS,
  DETAIL_FAILURE
)<number, DronData, AxiosError>();

export const RESET_IDNTF = createAction(DISPATCH_RESET_IDNTF)();

export const IDNTF_CREATE = createAsyncAction(
  IDNTF_CREATE_REQUEST,
  IDNTF_CREATE_SUCCESS,
  IDNTF_CREATE_FAILURE
)<IdntfData[], string, AxiosError>();

export const CREATE = createAsyncAction(
  CREATE_REQUEST,
  CREATE_SUCCESS,
  CREATE_FAILURE
)<DronData, string, AxiosError>();

export const UPDATE = createAsyncAction(
  UPDATE_REQUEST,
  UPDATE_SUCCESS,
  UPDATE_FAILURE
)<DronData, String, AxiosError>();

export const DELETE = createAsyncAction(
  DELETE_REQUEST,
  DELETE_SUCCESS,
  DELETE_FAILURE
)<number, string, AxiosError>();

export const IDNTF_DELETE = createAsyncAction(
  IDNTF_DELETE_REQUEST,
  IDNTF_DELETE_SUCCESS,
  IDNTF_DELETE_FAILURE
)<string, string, AxiosError>();

export const SELECT = createAction(SELECT_GROUP)<SelectData>();

const actions = {
  LIST,
  DETAIL,
  CREATE,
  UPDATE,
  DELETE,
  IDNTF_LIST,
  IDNTF_CREATE,
  IDNTF_DELETE,
  RESET_IDNTF,
  SELECT
};

export type DronAction = ActionType<typeof actions>;
